import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full h-screen bg-green-500 flex justify-center items-center p-10" }
const _hoisted_2 = { class: "w-full h-full bg-white rounded-3xl flex flex-row" }
const _hoisted_3 = { class: "w-2/3 border-r-4 border-gray-50 flex pl-20 pr-10" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl mt-10" }, "Hi~", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl mt-5" }, [
  /*#__PURE__*/_createTextVNode(" 欢迎使用"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gyjdGreen-500" }, " 指引解读"),
  /*#__PURE__*/_createTextVNode("学习系统 ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_8 = { class: "w-full my-6 flex items-center justify-center" }
const _hoisted_9 = { class: "tabs tabs-boxed" }
const _hoisted_10 = { class: "w-full px-2 py-3 flex flex-row items-center justify-center" }
const _hoisted_11 = { class: "w-1/3 overflow-y-auto scrollbar-thin scrollbar-thumb-gyjdGreen-600" }
const _hoisted_12 = { class: "bg-white rounded-3xl" }
const _hoisted_13 = { class: "mx-auto py-12 px-4" }
const _hoisted_14 = { class: "mx-auto" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center text-xl font-extrabold text-gray-900 flex flex-row justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-10" }, " FAQs ")
], -1)
const _hoisted_16 = { class: "mt-2 space-y-4 divide-y" }
const _hoisted_17 = { class: "text-base" }
const _hoisted_18 = { class: "font-medium text-gray-900" }
const _hoisted_19 = { class: "ml-6 h-7 flex items-center" }
const _hoisted_20 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_21 = { class: "link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginByScan = _resolveComponent("LoginByScan")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentTab = 1)),
                class: _normalizeClass([_ctx.currentTab == 1 ? ' bg-gyjdGreen-500 text-white' : '', 'tab  rounded-lg '])
              }, " 微信扫码登录", 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.currentTab == 1)
              ? (_openBlock(), _createBlock(_component_LoginByScan, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("dl", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (faq) => {
                  return (_openBlock(), _createBlock(_component_Disclosure, {
                    as: "div",
                    key: faq.question,
                    class: "pt-6"
                  }, {
                    default: _withCtx(({ open }) => [
                      _createElementVNode("dt", _hoisted_17, [
                        _createVNode(_component_DisclosureButton, { class: "text-left w-full flex justify-between items-start text-gray-400" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(faq.question), 1),
                            _createElementVNode("span", _hoisted_19, [
                              _createVNode(_component_ChevronDownIcon, {
                                class: _normalizeClass([open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform']),
                                "aria-hidden": "true"
                              }, null, 8, ["class"])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createVNode(_component_DisclosurePanel, {
                        as: "dd",
                        class: "mt-2 pr-12"
                      }, {
                        default: _withCtx(() => [
                          (!faq.router)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(faq.answer), 1))
                            : _createCommentVNode("", true),
                          (faq.router)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                target: "_blank",
                                to: { path: faq.router }
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(faq.answer), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}